export const API_BASE = import.meta.env.VITE_API_BASE_URL || "https://valuate-api.vercel.app/api/v1";

// Extract property ID safely from URL: /data-dashboard/property/valuation/:id
function getPropertyIdFromUrl(): string | null {
  const match = window.location.pathname.match(
    /property\/valuation\/([^/]+)/i
  );

  if (!match) return null;

  return match[1] ?? null;
}

export async function submitPropertyJson(payload: Record<string, any>) {
  const token = localStorage.getItem("valuation_token");
  const id = getPropertyIdFromUrl();

  if (!token) {
    throw new Error("Not authorized. Please log in again.");
  }

  if (!id) {
    throw new Error("Invalid property ID in URL.");
  }

  const response = await fetch(`${API_BASE}/properties/${id}`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      valuationDetails: payload,
    }),
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(
      errorText || "Failed to submit property valuation data."
    );
  }

  return response.json();
}
